export const OFFICELOCATION = [
  { name: "Nairobi", link: "/" },
  { name: "adams", link: "/" },
];
export const OPERATINGHOURS = [
  { name: "Monday to friday 7am - 8pm ", link: "/" },
  { name: "Saturday to Sunday 10am - 4pm ", link: "/" },
];
export const INFORMATIONAL = [
  { name: "phone +254 79 77 82 614" },
  {
    name: "Email-Kastillocleaners@gmail.com",
    link: "Email-Kastillocleaners@gmail.com",
  },
];
export const Icons = [
  // { name: "logo-facebook", link: "/" },
  {
    name: "logo-instagram",
    link: "https://www.instagram.com/kastilo_cleaners/",
  },
  // { name: "logo-whatsapp", link: "/" },
  {
    name: "logo-linkedin",
    link: "http://linkedin.com/in/martin-odongo-77248120a",
  },
];
